module.exports = __webpack_public_path__ + "static/cover@2x-5739a27022a0e97ae58ab70974d3e01f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/buzzfeed/cover@2x.jpg
// module id = 113
// module chunks = 3627797113349 20562973939449 33019919093843